import { createContext, useContext, useState } from 'react';

const CreateSheetContext = createContext(null);

export const useCreateSheet = () => useContext(CreateSheetContext);

export const CreateSheetProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <CreateSheetContext.Provider value={{
      isOpen,
      open:  () => setIsOpen(true),
      close: () => setIsOpen(false),
    }}>
      {children}
    </CreateSheetContext.Provider>
  );
};
